import { render, staticRenderFns } from "./NotificationFundraisingDonationCreated.vue?vue&type=template&id=0986b6fa&"
import script from "./NotificationFundraisingDonationCreated.vue?vue&type=script&lang=ts&"
export * from "./NotificationFundraisingDonationCreated.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports